<!-- ORGANISM: AccountMenuCard.vue -->

<script setup lang="ts">
//
// Imports
//
import AccountMenuCardHeading from "../molecules/AccountMenuCardHeading.vue";
import AccountMenuCardLanguage from "../molecules/AccountMenuCardLanguage.vue";
import AccountMenuCardSignOut from "../molecules/AccountMenuCardSignOut.vue";

//
// Props
//
withDefaults(
  defineProps<{
    userName: string;
    userEmail: string;
    userInitials: string;
    avatarColor?: string;
    logout: () => void;
  }>(),
  {
    avatarColor: "primary",
  },
);
</script>

<template>
  <v-card width="20rem" rounded="lg" elevation="10" class="text-primary pb-2">
    <!-- Heading -->
    <account-menu-card-heading
      :user-name="userName"
      :user-email="userEmail"
      :user-initials="userInitials"
      :avatar-color="avatarColor"
    />

    <!-- Language -->
    <account-menu-card-language />

    <!-- Sign Out -->
    <account-menu-card-sign-out :logout="logout" />
  </v-card>
</template>
